export default {
	breadcrumbPages: (state) => state.list
};



// WEBPACK FOOTER //
// ./sources/components/breadcrumb/getters.js